"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var DocIcon = function DocIcon(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    viewBox: "0 0 20 20",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React.createElement("title", null, "icon/doc"), /*#__PURE__*/React.createElement("g", {
    id: "OCR",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/doc"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\u77E9\u5F62",
    x: "0",
    y: "0",
    width: "20",
    height: "20"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\u7F16\u7EC4-3",
    transform: "translate(2.500000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,15 C15,15.5522847 14.5522847,16 14,16 L2,16 C1.44771525,16 1,15.5522847 1,15 L1,1 C1,0.44771525 1.44771525,1.01453063e-16 2,0 L11,0 L15,4 L15,15 Z",
    id: "\u5F62\u72B6\u7ED3\u5408",
    fill: "#E7F3FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\u77E9\u5F62",
    fill: "#1688FF",
    x: "0",
    y: "8",
    width: "13",
    height: "6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.655,13 C3.235,13 3.67,12.84 3.97,12.52 C4.255,12.215 4.4,11.78 4.4,11.215 C4.4,10.645 4.255,10.21 3.97,9.91 C3.67,9.59 3.235,9.43 2.655,9.43 L1.35,9.43 L1.35,13 L2.655,13 Z M2.545,12.5 L1.935,12.5 L1.935,9.93 L2.545,9.93 C2.99,9.93 3.315,10.03 3.52,10.235 C3.72,10.435 3.82,10.765 3.82,11.215 C3.82,11.655 3.72,11.98 3.52,12.19 C3.315,12.395 2.99,12.5 2.545,12.5 Z M6.535,13.07 C7.08,13.07 7.51,12.895 7.825,12.545 C8.125,12.21 8.275,11.77 8.275,11.22 C8.275,10.67 8.125,10.225 7.825,9.89 C7.51,9.535 7.08,9.36 6.535,9.36 C5.985,9.36 5.555,9.535 5.245,9.895 C4.945,10.235 4.8,10.675 4.8,11.22 C4.8,11.76 4.945,12.2 5.245,12.54 C5.555,12.89 5.985,13.07 6.535,13.07 Z M6.535,12.555 C6.165,12.555 5.875,12.43 5.675,12.185 C5.48,11.945 5.385,11.625 5.385,11.22 C5.385,10.81 5.48,10.49 5.675,10.25 C5.88,10 6.165,9.875 6.535,9.875 C6.905,9.875 7.19,9.99 7.39,10.23 C7.585,10.47 7.685,10.8 7.685,11.22 C7.685,11.64 7.585,11.965 7.39,12.2 C7.19,12.435 6.905,12.555 6.535,12.555 Z M10.385,13.07 C10.77,13.07 11.1,12.96 11.375,12.74 C11.67,12.505 11.855,12.18 11.935,11.76 L11.365,11.76 C11.295,12.03 11.175,12.235 11.005,12.37 C10.845,12.49 10.635,12.555 10.38,12.555 C9.99,12.555 9.7,12.43 9.515,12.19 C9.345,11.965 9.26,11.64 9.26,11.22 C9.26,10.81 9.345,10.49 9.52,10.26 C9.71,10 9.99,9.875 10.365,9.875 C10.615,9.875 10.82,9.925 10.98,10.035 C11.145,10.145 11.255,10.315 11.315,10.55 L11.885,10.55 C11.83,10.19 11.675,9.9 11.415,9.69 C11.145,9.47 10.795,9.36 10.375,9.36 C9.805,9.36 9.37,9.545 9.07,9.925 C8.805,10.255 8.675,10.69 8.675,11.22 C8.675,11.76 8.8,12.19 9.055,12.51 C9.345,12.88 9.79,13.07 10.385,13.07 Z",
    id: "DOC",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9990397,4 L12,4 C11.4477153,4 11,3.55228475 11,3 L11,0 L11,0 L14.9990397,4 Z",
    id: "\u77E9\u5F62\u5907\u4EFD-11",
    fill: "#B9DBFF"
  })))));
};
var _default = DocIcon;
exports["default"] = _default;